export const EDIT_FIELD_MFE_MODULE = 'fields/edit';

export const FIELDS_MFE_REFRESH_DEBOUNCE_MS = 300;
// The backend updates aggregates such as field_count asynchronously (the Entities Hall MFE waits
// too), so the queries that carry them are invalidated a bit later.
export const FIELDS_MFE_AGGREGATES_DELAY_MS = 2000;

// Dispatched on window by the Fields MFE when fields are edited, renamed, archived or deleted.
export const FIELDS_LIST_CHANGED_EVENT = 'CW:FIELDS:LIST-CHANGED';

// Dispatched on window by the Season Management MFE (e.g. the fields/edit Season tab) when
// cropzones are saved, removed or created.
export const SEASON_MGT_CROPZONES_CHANGED_EVENT = 'CW:SEASON-MGT:CROPZONES-CHANGED';
